package com.example.hukakmp.ui.theme

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Typography
import androidx.compose.material3.darkColorScheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.sp

// Paleta oficial Huka Web: celeste de marca + azul marino profundo.
private val HukaBlue = Color(0xFF11A8EA)
private val HukaBlueBright = Color(0xFF22C7F3)
private val HukaCyan = Color(0xFF12C9D7)
private val HukaNavy = Color(0xFF031B29)
private val HukaNavySoft = Color(0xFF06263A)
private val HukaCard = Color(0xFF082E49)
private val HukaCardEdge = Color(0xFF0877BE)
private val HukaIce = Color(0xFFF5FBFF)
private val HukaInk = Color(0xFF082435)
private val HukaMuted = Color(0xFF607D8E)

private val LightColors = lightColorScheme(
    primary = HukaBlue,
    onPrimary = Color.White,
    primaryContainer = Color(0xFFDDF5FF),
    onPrimaryContainer = Color(0xFF00344F),
    secondary = HukaCyan,
    onSecondary = Color(0xFF00363B),
    secondaryContainer = Color(0xFFD4F8FB),
    onSecondaryContainer = Color(0xFF00363B),
    tertiary = Color(0xFFFFB020),
    onTertiary = Color(0xFF422C00),
    tertiaryContainer = Color(0xFFFFE7B1),
    onTertiaryContainer = Color(0xFF2B1D00),
    error = Color(0xFFBA1A1A),
    onError = Color.White,
    errorContainer = Color(0xFFFFDAD6),
    onErrorContainer = Color(0xFF410002),
    background = HukaIce,
    onBackground = HukaInk,
    surface = Color.White,
    onSurface = HukaInk,
    surfaceVariant = Color(0xFFE4F2F8),
    onSurfaceVariant = HukaMuted,
    outline = Color(0xFF7894A4),
    inverseOnSurface = Color(0xFFEAF7FC),
    inverseSurface = HukaNavySoft,
    inversePrimary = HukaBlueBright,
)

private val DarkColors = darkColorScheme(
    primary = HukaBlueBright,
    onPrimary = Color(0xFF002F43),
    primaryContainer = Color(0xFF084E70),
    onPrimaryContainer = Color(0xFFD8F4FF),
    secondary = HukaCyan,
    onSecondary = Color(0xFF00373B),
    secondaryContainer = Color(0xFF07535A),
    onSecondaryContainer = Color(0xFFD2F8FB),
    tertiary = Color(0xFFFFC857),
    onTertiary = Color(0xFF402D00),
    tertiaryContainer = Color(0xFF5D4300),
    onTertiaryContainer = Color(0xFFFFE7A4),
    error = Color(0xFFFFB4AB),
    onError = Color(0xFF690005),
    errorContainer = Color(0xFF93000A),
    onErrorContainer = Color(0xFFFFDAD6),
    background = HukaNavy,
    onBackground = Color(0xFFF3FAFF),
    surface = HukaNavySoft,
    onSurface = Color(0xFFF3FAFF),
    surfaceVariant = HukaCard,
    onSurfaceVariant = Color(0xFFC6DCEC),
    outline = HukaCardEdge,
    inverseOnSurface = HukaNavy,
    inverseSurface = Color(0xFFEAF7FC),
    inversePrimary = HukaBlue,
)

private val HukaTypography = Typography(
    bodyLarge = TextStyle(
        fontFamily = FontFamily.Default,
        fontWeight = FontWeight.Normal,
        fontSize = 16.sp,
        lineHeight = 24.sp,
        letterSpacing = 0.2.sp,
    ),
    titleLarge = TextStyle(
        fontFamily = FontFamily.Default,
        fontWeight = FontWeight.Bold,
        fontSize = 22.sp,
        lineHeight = 28.sp,
        letterSpacing = 0.sp,
    ),
    titleMedium = TextStyle(
        fontFamily = FontFamily.Default,
        fontWeight = FontWeight.SemiBold,
        fontSize = 16.sp,
        lineHeight = 22.sp,
        letterSpacing = 0.1.sp,
    ),
    labelSmall = TextStyle(
        fontFamily = FontFamily.Default,
        fontWeight = FontWeight.Medium,
        fontSize = 11.sp,
        lineHeight = 16.sp,
        letterSpacing = 0.4.sp,
    ),
)

@Composable
fun HukaTheme(
    darkTheme: Boolean = isSystemInDarkTheme(),
    content: @Composable () -> Unit,
) {
    MaterialTheme(
        colorScheme = if (darkTheme) DarkColors else LightColors,
        typography = HukaTypography,
        content = content,
    )
}
